/**
 * Zustand slice for whole-report-record mutations: replacing/patching the loaded report
 * (setReport/updateReport — used by both reportEditorPage/ and the legacy reportPage/),
 * plus the section/note CRUD actions used by reportPage/'s per-section editing UI.
 */
export const createReportRecordSlice = (set, get) => ({
    setReport: (report) => {
        const reportId = report?.id || report?.reportId;
        if (!reportId) {
            set({...report});
            return;
        }

        // Set the report
        set({...report});
    },

    updateReport: (updatedFields) =>
        set((state) => ({...state, ...updatedFields})),

    addSection: (section) =>
        set((state) => ({sections: [...state.sections, section]})),

    updateSection: (updatedSection) =>
        set((state) => ({
            sections: state.sections.map(section =>
                section.sectionId === updatedSection.id ? {...section, ...updatedSection} : section
            )
        })),

    deleteSectionById: (sectionId) =>
        set((state) => ({
            sections: state.sections.filter(section => section.sectionId !== sectionId),
        })),

    addSegmentToSection: (sectionId, segment) =>
        set((state) => {
            if (sectionId === 'uncategorized') {
                return {notes: [segment, ...(state.notes || [])]};
            }
            return {
                sections: state.sections.map(section =>
                    section.sectionId === sectionId
                        ? {...section, notes: [segment, ...(section.notes || [])]}
                        : section
                )
            };
        }),

    removeSegmentFromSection: (sectionId, noteId) =>
        set((state) => {
            if (sectionId === 'uncategorized') {
                return {notes: state.notes.filter(note => note.noteId !== noteId)};
            }
            return {
                sections: state.sections.map(section =>
                    section.sectionId === sectionId
                        ? {...section, notes: section.notes.filter(note => note.noteId !== noteId)}
                        : section
                )
            };
        }),

    updateSectionTitle: (id, title) =>
        set((state) => ({
            sections: (state.sections || []).map(sec =>
                sec.sectionId === id ? {...sec, title} : sec
            )
        })),

    updateSectionDescription: (id, description) =>
        set((state) => ({
            sections: (state.sections || []).map(sec =>
                sec.sectionId === id ? {...sec, description} : sec
            )
        })),

    addReport: (report) =>
        set((state) => ({reports: [...state.reports, report]})),
});
